module.exports = __webpack_public_path__ + "img/activity.f0a59e6c.svg";